import { render, staticRenderFns } from "./ServiceproviderMarket.vue?vue&type=template&id=928fccda&"
import script from "./ServiceproviderMarket.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports